import AbstractConfig from "../../../core/config/AbstractConfig";
import MapCharacterDefinition from "./MapCharacterDefinition";
import MapDefinition from "./MapDefinition";
import MapLocationDefinition from "./MapLocationDefinition";

export default class MapsConfig extends AbstractConfig {
    constructor() {
        super();

        this._memoizedMaps = null;
    }

    /**
     * @returns {Array<MapDefinition>}
     */
    get maps() {
        if (this._memoizedMaps) {
            return this._memoizedMaps;
        }

        const mapsObj = this.getValue('maps');

        const mapDefinitions = [];
        for (const [key, value] of Object.entries(mapsObj)) {
            const mapDefinition = new MapDefinition(
                key,
                value?.movieClipName,
                value?.locations?.map(n => new MapLocationDefinition(n.id, n.instanceName, n.imageId)),
                value?.characters?.map(n => new MapCharacterDefinition(n.id, n.location, n.imageId))
            );
            mapDefinitions.push(mapDefinition);
        }

        this._memoizedMaps = mapDefinitions;
        return this._memoizedMaps;
    }

    getMapById(mapId) {
        return this.maps.find(m => m.id === mapId);
    }
}
